module.exports = __webpack_public_path__ + "media/softinyalms-en.f8060c3d.mp4";